import { connect } from 'react-redux';
import classnames from 'classnames';
import React, { Component } from 'react';
import DisableEditIcon from '@/assets/images/icons/trade_icon_amend_disable.png';
import LightDisableEditIcon from '@/assets/images/icons/light/trade_icon_amend_disable.png';
import EditIcon from '@/assets/images/icons/trade_icon_amend_normal.png';
import LightEditIcon from '@/assets/images/icons/light/trade_icon_amend_normal.png';
import DisableCancelIcon from '@/assets/images/icons/trade_icon_cancel_disable.png';
import LightDisableCancelIcon from '@/assets/images/icons/light/trade_icon_cancel_disable.png';
import CancelIcon from '@/assets/images/icons/trade_icon_cancel_normal.png';
import LightCancelIcon from '@/assets/images/icons/light/trade_icon_cancel_normal.png';
import { dataType } from '@/constants/data-type';
import { formatFunctions, utilsFunction } from '../../helpers/functions';
import BuySellAction from '@/components/DataTable/CellRenderComponents/BuySellAction';
import CACellRender from '@/components/DataTable/CellRenderComponents/CACellRender';
import IPOCellRender from './CellRenderComponents/IPOCellRender';
import OrderCellRender from '@/components/DataTable/CellRenderComponents/OrderCellRender';
import TransactionHistoryCellRender from '@/components/DataTable/CellRenderComponents/TransactionHistoryCellRender';
import NameRender from '@/components/DataTable/CellRenderComponents/NameRender';

import { APP_LANGUAGE_SUPPORTS } from '@/constants/app';

var ARROW_UP = '\u2191';
var ARROW_DOWN = '\u2193';
const REFRESH_COLS = [
  'bid_price_1', 'bid_vol_1', 'bid_price_2', 'bid_vol_2', 'bid_price_3', 'bid_vol_3',
  'ask_price_1', 'ask_vol_1', 'ask_price_2', 'ask_vol_2', 'ask_price_3', 'ask_vol_3',
  'matched_price', 'matched_volume', 'change', 'symbol',
  'ceil', 'floor', 'ref'
]


class CustomRenderer extends Component {
  constructor(props) {
    super(props);
    this.lastValue = null;
    this.refreshCount = 0;
    this.refTimeout = null
    this.warpTextHeightMap = {}
  }

  render() {
    const { colDef, value, data } = this.props;

    return (
      <div className={this.getClassName(value, colDef)} ref={e => this.cellContainerRef = e}>
        {this.renderCellContent()}
      </div>
    );
  }

  renderCellContent() {
    const { colDef, value } = this.props;
    switch (colDef.dataType) {
      case dataType.BUY_SELL: {
        return this.renderActionsCol()
      }
      case dataType.EDIT_CANCEL: {
        return this.renderActionsEditCancel();
      }
      case dataType.SYMBOL: {
        return this.renderSymbol();
      }
      case dataType.IPO_CELL_RENDER: {
        return this.renderIPOCell(colDef);
      }
      case dataType.CA_CELL_RENDER: {
        return this.renderCACell(colDef);
      }
      case dataType.ORDER_CELL_RENDER: {
        return this.renderOrderCell(colDef);
      }
      case dataType.FLOATING_PL_PERCENT: {
        return this.renderFloating(colDef)
      }
      case dataType.PERCENT: {
        return this.renderPercent(colDef)
      }
      case dataType.TRANSACTION_HISTORY_STATUS: {
        return this.renderTransactionHistoryStatus(colDef)
      }
      case dataType.STOCK_NAME: {
        return this.renderStockName(colDef)
      }
      default: {
        return this.renderDefault(value, colDef);
      }
    }
  }

  renderDefault(value, colDef) {
    const { action, data } = this.props 
    return (
      <div className={classnames(colDef.cellClass)}>
        <span ref={e => this.iconRef = e} style={{ marginRight: 5 }}></span>
        <span ref={e => this.valueRef = e}
          onClick={() => action && action(data)}
          className={classnames(action && 'has-action')}
        >{formatFunctions.dataFormat(value, colDef.dataType)}</span>
      </div>
    )
  }

  renderActionsCol() {
    const { data } = this.props;
    return <BuySellAction data={data} />
  }

  renderActionsEditCancel() {
    const { data, browser, theme } = this.props;
    const isDisableModify = data.isModifiable === 'N';
    const isDisableCancel = data.isCancelable === 'N';
    const NewCancelIcon = (browser==='ie'&&theme==='light'?LightCancelIcon:CancelIcon);
    const NewEditIcon = (browser==='ie'&&theme==='light'?LightEditIcon:EditIcon);
    const NewDisableCancelIcon = (browser==='ie'&&theme==='light'?LightDisableCancelIcon:DisableCancelIcon);
    const NewDisableEditIcon = (browser==='ie'&&theme==='light'?LightDisableEditIcon:DisableEditIcon);
    return (
      <div className="item-fl-action-row">
        <button className={classnames('btn-table-icon', isDisableModify && 'btn-table-icon-disable')}
          onClick={() => !isDisableModify && this.props.onEditOrder(data)}
          disabled={isDisableModify}>
          <img src={isDisableModify ? NewDisableEditIcon : NewEditIcon} alt='edit_icon' />
        </button>
        <button className={classnames('btn-table-icon', isDisableCancel && 'btn-table-icon-disable')}
          onClick={() => !isDisableCancel && this.props.onCancelOrder(data)}
          disabled={isDisableCancel}>
          <img src={isDisableCancel ? NewDisableCancelIcon : NewCancelIcon} alt='cancel_icon' />
        </button>
      </div>
    )
  }

  renderSymbol() {
    const { data, value, market, instrument, action } = this.props;
    let text = (market && instrument) ? `${data[market] && data[instrument] ? data[market] + '.' + data[instrument] : '-'}` : value;
    return (
      <div>
        <span
          style={{ cursor: action ? 'pointer' : 'default' }}
          onClick={() => action && this.props.action(data)}>
          {text}
        </span>
      </div>
    )
  }

  renderIPOCell(colDef) {
    const { data } = this.props;
    return (
      <IPOCellRender data={data} colDef={colDef} />
    )
  }

  renderCACell(colDef) {
    const { data } = this.props;
    return <CACellRender data={data} colDef={colDef} />
  }

  renderOrderCell(colDef) {
    const { data } = this.props;
    return <OrderCellRender data={data} colDef={colDef}/>
  }

  renderFloating() {
    const { data, value, percent, floating, action } = this.props;
    let text = (percent && floating) ? `${(Number(value) > 0 ? '+' : (Number(value) === 0 ? '' : '')) + formatFunctions.dataFormat(data[floating], dataType.CASH)}(${(Number(value) > 0 ? '+' : (Number(value) === 0 ? '' : '')) + utilsFunction.currencyFormatter(data[percent], 2)}%)` : value;
    return (
      <div style={{ cursor: action ? 'pointer' : 'default', textAlign: 'right' }}>
        {text}
      </div>
    )
  }

  renderPercent(colDef) {
    const { data } = this.props;
    return <div style={{ textAlign: 'right' }}>{`${data['change']}%`}</div>
  }

  renderTransactionHistoryStatus(colDef) {
    const { data } = this.props;
    return <TransactionHistoryCellRender data={data} colDef={colDef} />
  }

  renderStockName() {
    const { data, stockName, chineseStockName } = this.props;
    return <NameRender data={data} stockName={stockName} chineseStockName={chineseStockName} />
  }

  resetWrapTextHeight() {
    if (this.props.colDef.wrapText && this.props.value) {
      this.refTimeout && clearTimeout(this.refTimeout)
      this.refTimeout = setTimeout(() => {
        const field = this.props.colDef.field
        const offsetHeight = this.valueRef?.offsetHeight
        if (typeof offsetHeight === 'number' && offsetHeight) {
          this.warpTextHeightMap[this.props.value] = offsetHeight
          this.props.api.forEachNode(rowNode => {
            setTimeout(() => {
              const height = this.warpTextHeightMap[rowNode.data[field]]
              if (height) {
                rowNode.setRowHeight(height + 15)
              }
              this.props.api.onRowHeightChanged()
            }, 50)
          })
        }
      })
    }
  }

  componentDidMount() {
    if (REFRESH_COLS.includes(this.props.colDef.field))
      this.refresh(this.props);
    this.resetWrapTextHeight();
  }


  getClassName(value, colDef) {
    const classes = [];
    classes.push('cell-content')
    classes.push(this.renderContentClassNamesByType(colDef.dataType))
    if (colDef.bindingColor) {
      classes.push(this.bindingColor(value))
    }
    return classes.join(' ');
  }

  renderContentClassNamesByType(type) {
    switch (type) {
      case dataType.TEXT:
        return "text-left"
      case dataType.REF:
        return "text-center"
      case dataType.NUMBER:
        return "text-right"
      case dataType.CURRENCY:
        return "text-right"
      case dataType.CASH:
        return "text-right"
      case dataType.AVG_PRICE:
        return "text-right"
      default:
        return null
    }
  }

  bindingColor(value) {
    if (value > 0) {
      return 'rise-color'
    } else if (value < 0) {
      return 'fall-color'
    } else {
      return ''
    }
  }

  refresh(params) {
    const field = params.colDef.field;
    const data = params.data;

    var value = params.value;
    var delta = this.getDeltaBaseOnRefPrice(field, data);
    if (!isNaN(delta)) {
      this.bindingPriceColor(field, delta);
    }
    if (value === this.lastValue) {
      return;
    }
    if (this.isExists(params.valueFormatted)) {
      if (this.valueRef)
        this.valueRef.innerHTML = params.valueFormatted;
    } else if (this.isExists(params.value)) {
      if (this.valueRef)
        this.valueRef.innerHTML = value;
    } else {
      this.clearElement(this.valueRef);
    }

    if (this.lastValue && !isNaN(value)) {
      let changeValue = parseFloat(`${value}`.replace(/,/g, '')) - parseFloat(`${this.lastValue}`.replace(/,/g, ''))
      this.showHighlight(changeValue);
    }
    this.setTimerToRemoveHighlight();
    this.lastValue = value;
    return true;
  }

  getDeltaBaseOnRefPrice(field, data) {
    let key = '';
    if (['bid_price_1', 'bid_vol_1'].includes(field)) {
      key = 'bid_price_1';
    }
    else if (['bid_price_2', 'bid_vol_2'].includes(field)) {
      key = 'bid_price_2';
    }
    else if (['bid_price_3', 'bid_vol_3'].includes(field)) {
      key = 'bid_price_3';
    }
    else if (['ask_price_1', 'ask_vol_1'].includes(field)) {
      key = 'ask_price_1';
    }
    else if (['ask_price_2', 'ask_vol_2'].includes(field)) {
      key = 'ask_price_2';
    }
    else if (['ask_price_3', 'ask_vol_3'].includes(field)) {
      key = 'ask_price_3';
    }
    else if (['matched_price', 'matched_volume', 'change', 'symbol'].includes(field)) {
      key = 'matched_price';
    }
    else if (['ceil', 'floor', 'ref'].includes(field)) {
      key = 'ref';
    }
    return key === '' ? NaN : data[key] - data['ref'];
  }

  bindingPriceColor(field, delta) {
    if (field === 'total_volume' || field === 'symbol') {
      return;
    } else if (field === 'ref') {
      this.addCssClass(this.valueRef, 'stock-data-ref');
    } else if (field === 'ceil') {
      this.addCssClass(this.valueRef, 'stock-data-ceil');
    } else if (field === 'floor') {
      this.addCssClass(this.valueRef, 'stock-data-floor');
    } else {
      this.addOrRemoveCssClass(this.valueRef, 'change-delta-up', delta > 0);
      this.addOrRemoveCssClass(this.valueRef, 'change-delta-down', delta < 0);
      this.addOrRemoveCssClass(this.valueRef, 'change-delta', delta === 0);
    }
  }

  setTimerToRemoveHighlight() {
    var _this = this;
    // the refreshCount makes sure that if the value updates again while
    // the below timer is waiting, then the below timer will realise it
    // is not the most recent and will not try to remove the delta value.
    this.refreshCount++;
    var refreshCountCopy = this.refreshCount;
    window.setTimeout(function () {
      if (refreshCountCopy === _this.refreshCount) {
        _this.hideHighlight();
      }
    }, 1000);
  }

  hideHighlight() {
    this.removeCssClass(this.cellContainerRef, 'change-value-highlight-up');
    this.removeCssClass(this.cellContainerRef, 'change-value-highlight-down');
    // this.removeCssClass(this.cellContainerRef, 'change-value-highlight');
    this.clearElement(this.iconRef);
  }

  showHighlight(deltaLastValue) {
    if (deltaLastValue > 0) {
      // this.iconRef.innerHTML = `${ARROW_UP} ${this.lastValue}`;
      this.iconRef.innerHTML = ARROW_UP;
    } else if (deltaLastValue < 0) {
      this.iconRef.innerHTML = ARROW_DOWN;
    }
    this.addOrRemoveCssClass(this.cellContainerRef, 'change-value-highlight-up', deltaLastValue > 0);
    this.addOrRemoveCssClass(this.valueRef, 'white-color', deltaLastValue > 0);
    this.addOrRemoveCssClass(this.cellContainerRef, 'change-value-highlight-down', deltaLastValue < 0);
  }

  isExists(value, allowEmptyString) {
    if (allowEmptyString === void 0) {
      allowEmptyString = false;
    }
    return value != null && (allowEmptyString || value !== '');
  }

  clearElement(target) {
    if (target) {
      target.innerHTML = '';
    }
  }

  removeCssClass(target, ...classNames) {
    classNames.forEach(className => {
      if (target && target.classList) {
        target.classList.remove(className);
      }
    })
  }

  addCssClass(target, ...classNames) {
    classNames.forEach(className => {
      if (target && target.classList) {
        target.classList.add(className);
      }
    })
  }

  addOrRemoveCssClass(target, className, addOrRemove) {
    if (addOrRemove) {
      this.addCssClass(target, className);
    }
    else {
      this.removeCssClass(target, className);
    }
  }
}

export default connect(
  state => ({
    browser:state.app.browser,
    theme:state.app.theme
  }),
  dispatch => ({
  })
)(CustomRenderer)

